<script lang="ts">
  interface Props {
    size?: number;
    [key: string]: any;
  }

  let { size = 16, ...rest }: Props = $props();
</script>

<svg
  width={size}
  height={size}
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  {...rest}
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M11.5762 5.01988C11.8414 5.33809 11.7984 5.81101 11.4802 6.07618C9.81811 7.46123 8.80104 9.18641 8.24647 10.376L8.23549 10.3996C8.12526 10.6361 8.02592 10.8492 7.93591 11.0111C7.85842 11.1505 7.71073 11.4047 7.44779 11.5571C7.14138 11.7347 6.80688 11.7748 6.46718 11.6746L6.67939 10.9552L6.46717 11.6746C6.18169 11.5904 5.98389 11.3897 5.87463 11.2724C5.75337 11.1423 5.61404 10.9682 5.46269 10.7789L5.44622 10.7583L4.41438 9.46854C4.15562 9.14509 4.20806 8.67312 4.53151 8.41437C4.85495 8.15561 5.32692 8.20805 5.58568 8.5315L6.61753 9.82131C6.67314 9.89083 6.72155 9.95125 6.76421 10.004C6.79939 9.92989 6.83972 9.84354 6.88694 9.74223C7.49532 8.4372 8.62867 6.49987 10.5199 4.92385C10.8381 4.65868 11.311 4.70167 11.5762 5.01988Z"
    fill="currentColor"
  />
</svg>
